import { Button, Checkbox, Typography } from '@fullscreendigital/carrefour-dex-fe'
import { Box, Container, Grid, Paper } from '@mui/material'
import { FormInfoItems } from 'components/core-ui/FormInfoItems'
import { getInDeliverySeals } from 'components/shop-reception/mobile/api'
import { TitleHeader } from 'components/shop-reception/mobile/Common/TitleHeader'
import { useNotification } from 'hooks'
import { useNavigate, useSearchParams } from 'react-router-dom'
import s from './AddReportSelectSeals.modules.scss'
import { getReturoId, getReturoMaterialLabel } from 'components/shop-reception/mobile/helpers'
import { useMemo, useState } from 'react'
import { toNoticesSealsPayload } from './serializers'
import { useMutation } from 'react-query'
import { makeCorePostRequest } from 'utils/api'
import { formatErrorMessage } from 'utils/formatting'
import { URLS } from 'components/shop-reception/mobile/constants'
import { ReturoReportSeals, ReturoSeal } from 'components/shop-reception/mobile/interfaces'
import { getShopReceptionShops } from 'components/Layout/api'

const AddReportSelectSeals = () => {
  const [selectedSeals, setSelectedSeals] = useState<ReturoSeal[]>([])

  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const { data: seals, isLoading } = getInDeliverySeals(showNotification, setSelectedSeals)

  const [searchParams] = useSearchParams()
  const noticeId = searchParams.get('noticeId')
  const cmrNumber = searchParams.get('cmrNumber') || ''
  const truckNumber = searchParams.get('truckNumber') || ''
  const driverName = searchParams.get('driverName') || ''
  const providerName = searchParams.get('providerName') || ''

  //TODO discuss and remove if unnecessary
  const status = searchParams.get('noticeStatus')

  const toggleSeal = (seal: ReturoSeal) => {
    if (selectedSeals.some(item => item.id === seal.id)) {
      setSelectedSeals(selectedSeals.filter(item => item.id !== seal.id))
    } else {
      setSelectedSeals([...selectedSeals, seal])
    }
  }

  const saveReport = async (values: ReturoReportSeals) =>
    await makeCorePostRequest('/shop-reception-mobile/returo/notices/seals', values)

  const { mutate } = useMutation(saveReport, {
    onSuccess: () => {
      showNotification({
        message: 'Sigiliile au fost adăugate cu succes pe procesul verbal.',
        type: 'success'
      })
      navigate(`${URLS.AUTH_RETURO_ADD_REPORT_PRINT}?noticeId=${noticeId}`)
    },
    onError: res => {
      showNotification({
        message: `A aparut o eroare la salvarea datelor despre procesul verbal. ${formatErrorMessage(
          res
        )}`,
        type: 'error'
      })
    }
  })

  const saveSeals = () => {
    mutate(toNoticesSealsPayload(+noticeId, selectedSeals))
  }

  const { data: shops } = getShopReceptionShops(showNotification, true)

  const idReturo = useMemo(() => getReturoId(shops), [shops])

  return (
    <Container maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title={`ID Returo: ${idReturo}`} />
        </Grid>
        {seals?.length ? (
          <>
            <Grid item xs={12}>
              <FormInfoItems
                items={[
                  {
                    label: 'Număr CMR:',
                    name: cmrNumber
                  },
                  {
                    label: 'Număr camion:',
                    name: truckNumber
                  },
                  {
                    label: 'Şofer:',
                    name: driverName
                  },
                  {
                    label: 'Firma colectoare:',
                    name: providerName
                  }
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {seals?.map((item: ReturoSeal) => (
                  <Grid item xs={12} key={item.id}>
                    <Paper
                      elevation={3}
                      className={s.sealContainer}
                      onClick={() => toggleSeal(item)}
                    >
                      <Typography variant="medium" component="p">
                        <Checkbox
                          checked={selectedSeals?.some(seal => seal.id === item.id)}
                          onChange={() => {
                            toggleSeal(item)
                          }}
                        />
                      </Typography>
                      <Box>
                        <Typography variant="medium" component="p">
                          {item.sealCode} {getReturoMaterialLabel(item.materialType)}
                        </Typography>
                        <Typography variant="medium" component="p">
                          {item.createdBy}
                        </Typography>
                        <Typography variant="medium" component="p">
                          {item.created}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid xs={12} item>
              <Button
                type="submit"
                variant="contained"
                label="Pasul următor"
                style={{ width: '100%' }}
                onClick={saveSeals}
              />
            </Grid>
          </>
        ) : !isLoading ? (
          <Grid item xs={12}>
            Nu există sigilii în predare.
          </Grid>
        ) : null}
      </Grid>
    </Container>
  )
}

export default AddReportSelectSeals
